package com.xtream.data_kmp.remote


 import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.db.utils.XorEncDec
import com.xtream.data_kmp.dto.Account
import com.xtream.data_kmp.dto.Ad
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodStream
import io.ktor.client.HttpClient
import io.ktor.client.call.body
 import io.ktor.client.request.delete
 import io.ktor.client.request.forms.MultiPartFormDataContent
import io.ktor.client.request.forms.formData
import io.ktor.client.request.forms.submitForm
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.request.parameter
 import io.ktor.client.request.patch
 import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.request.url
import io.ktor.client.statement.HttpResponse
 import io.ktor.http.ContentType
 import io.ktor.http.contentType
 import io.ktor.http.isSuccess
import io.ktor.http.parameters

class ApiServiceImpl: ApiService {
    private val client: HttpClient
    private val baseUrl:String
    private  val username:String?
    private  val password:String?
    private  val activationCode:String?
    constructor(client: HttpClient,
                baseUrl:String,
                username:String,
                password:String){
        this.client=client
        this.baseUrl=baseUrl
        this.username=username
        this.password=password
        this.activationCode=null
    }


    constructor(client: HttpClient,
                baseUrl:String,
               activationCode:String){
        this.client=client
        this.baseUrl=baseUrl
        this.username=null
        this.password=null
        this.activationCode=activationCode
    }

    constructor(client: HttpClient,
                baseUrl:String){
        this.client=client
        this.baseUrl=baseUrl
        this.username=null
        this.password=null
        this.activationCode=null
    }
    override suspend fun login(): HttpResponse {
        val response=  client.get {

            url(baseUrl)

            parameter("username", username)
            parameter("password", password)
        }
        return response




    }

    override suspend fun activate(data:String): HttpResponse {
        return client.submitForm(
            url = baseUrl,
            formParameters = parameters {
                append("json", data)
            }
        )
    }

    override suspend fun userLogin(): Account? {
       val response=  client.get {

            url(baseUrl)

            parameter("username", username)
            parameter("password", password)
        }
       return when   {
           response.status.isSuccess()->{
               response.body()
           } else ->{
               throw Exception("MESSAGE")
           }
       }


    }

    override suspend fun activationLogin(data:String): Account? {
       return client.post {

            url(baseUrl)



            setBody(MultiPartFormDataContent(parts = formData {
                append("json", XorEncDec.encDec(data))
            }))
        }.body()
    }

    override suspend fun getLiveStreams(): List<LiveStream>? {
       val a=  client.get {
            url(baseUrl)
            parameter("username", username)
            parameter("password", password)
            parameter("action", AllConst.CNT_LIVE_STREAMS_ACTION)
        }
//    Log.d("#dataLoading", "request getSeriesStreams,url: $baseUrl?username=$username&password=$password&action=${AllConst.CNT_LIVE_STREAMS_ACTION}, response: ${a.bodyAsText()} ")

    return a.body()
    }

    override suspend fun getVodStreams(): List<VodStream>? {
      //  val millis = Clock.System.now().toEpochMilliseconds()

        val response=   client.get {
            url(baseUrl)

            parameter("username", username)
            parameter("password", password)
            parameter("action", AllConst.CNT_VOD_STREAMS_ACTION)

            //parameter("category_id","274"/*"505"*/ /*"384"*/)
        }
      //  Log.d("#dataLoading", "response getVodStreams finished in Sec: ${((Clock.System.now().toEpochMilliseconds() - millis) / 1000)}")
        return    response.body()
    }

    override suspend fun getSeriesStreams(): List<SeriesStream>? {
        return client.get {
            url(baseUrl)

            parameter("username", username)
            parameter("password", password)
            parameter("action", AllConst.CNT_SERIES_STREAMS_ACTION)

            //parameter("category_id","274"/*"505"*/ /*"384"*/)
        }.body()
    }

    override suspend fun getLiveCategories(): List<LiveCategory>? {
       return client.get {
           url(baseUrl)

           parameter("username", username)
           parameter("password", password)
           parameter("action", AllConst.CNT_LIVE_CATEGORIES_ACTION)

       }.body()
    }

    override suspend fun getVodCategories(): List<VodCategory>? {
        return client.get {
            url(baseUrl)

            parameter("username", username)
            parameter("password", password)
            parameter("action", AllConst.CNT_VOD_CATEGORIES_ACTION)

        }.body()    }

    override suspend fun getSeriesCategories(): List<SeriesCategory>? {
        return client.get {
            url(baseUrl)

            parameter("username", username)
            parameter("password", password)
            parameter("action", AllConst.CNT_SERIES_CATEGORIES_ACTION)

        }.body()    }

    override suspend fun getVodInfo(vodId:Int): HttpResponse {
       return client.get {
            url(baseUrl)

            parameter("username", username)
            parameter("password", password)
            parameter("action", AllConst.CNT_VOD_INFO)
            parameter("vod_id", vodId)

            //  parameter("category_id","505" /*"384"*/)
        }.body()
    }

    override suspend fun getSeriesInfo(streamId:Int): HttpResponse {

        try {


            return client.get {
                url(baseUrl)

                parameter("username", username)
                parameter("password", password)
                parameter("action", AllConst.CNT_SERIES_INFO)
                parameter("series_id", streamId)

                //  parameter("category_id","505" /*"384"*/)
            }
        }catch (e: Exception){
            throw e
        }
    }
override suspend fun getSubtitle(tmdbId: String? , apiKey: String?, appPackageId: String?): HttpResponse {
    return client.get{
        url(baseUrl.plus("/movie"))
        parameter("tmdb_id", tmdbId)
        header("Api_key",apiKey )
        header("package_name", appPackageId )

    }
}
    override suspend fun getSponsorBanner(): Ad {


       return client.get {
            url(baseUrl.plus("/sponsors_banner"))
        }.body()

    }

    override suspend fun getBanner(bannerType: String?): Ad {
         val response = client.get {
            url(baseUrl.plus("/banner"))
            parameter("banner_type", bannerType)
        }
       // Log.d( "TEST", response.bodyAsText())

        return response  .body()}


    override suspend fun getServerConfigs(): HttpResponse {
        val response = client.get {
            url(baseUrl)
        }
        return response
    }

    override suspend fun getTmdbMovieLogo(tmdbKey: String): HttpResponse {
       return client. get {
            url(baseUrl)

            header("Authorization", tmdbKey)

            //  parameter("category_id","505" /*"384"*/)
        }
    }
    override suspend fun tmdbTrendingMovies(tmdbKey:String): HttpResponse {
        val response = client.get {
            url("https://api.themoviedb.org/3/trending/movie/day?language=en-US")
            //parameter("banner_type", bannerType)
            header("Authorization",tmdbKey )

        }
        //Log.d( "TEST", response.bodyAsText())

        return response
    }


    override suspend fun tmdbTrendingTvShows(tmdbKey: String): HttpResponse {
        val response = client.get {
            url("https://api.themoviedb.org/3/trending/tv/day?language=en-US")
            //parameter("banner_type", bannerType)
            header("Authorization",tmdbKey )

        }

        return response
    }








    ///supabase
    // ----------------------------------------------------
// SUPABASE DEVICE MANAGEMENT
// ----------------------------------------------------
    override suspend fun getPlaylists(
        macAddress: String,
        apiKey: String
    ): HttpResponse {
        return client.get("$baseUrl/api/v1/device/playlists") {
            parameter("mac", macAddress)
            header("X-API-Key", apiKey)
        }
    }

    override suspend fun checkStatus(
        macAddress: String,
        apiKey: String
    ): HttpResponse {
        return client.get("$baseUrl/api/v1/device/activation") {
            parameter("mac", macAddress)
            header("X-API-Key", apiKey)
        }
    }

    override suspend fun registerDevice(
        macAddress: String,
        deviceKey: String,
        deviceName: String,
        model: String,
        modelVersion: String,
        appVersion: String,
        apiKey: String
    ): HttpResponse {
        return client.post("$baseUrl/api/v1/device/register") {
            header("X-API-Key", apiKey)
            contentType(ContentType.Application.Json)
            setBody(mapOf(
                "mac_address" to macAddress,
                "device_key" to deviceKey,
                "device_name" to deviceName,
                "model" to model,
                "model_version" to modelVersion,
                "app_version" to appVersion
            ))
        }
    }

    override suspend fun editPlaylist(
        playlistId: String,
        apiKey: String,
        body: Map<String, Any>
    ): HttpResponse {
        return client.patch("$baseUrl/api/v1/device/playlist/$playlistId") {
            header("X-API-Key", apiKey)
            contentType(ContentType.Application.Json)
            setBody(body)
        }
    }

    override suspend fun deletePlaylist(
        playlistId: String,
        apiKey: String
    ): HttpResponse {
        return client.delete("$baseUrl/api/v1/device/playlist/$playlistId") {
            header("X-API-Key", apiKey)
        }
    }
}